<template>
        <!-- PreLoader -->
		<div class="zirox-pre-loader" dir="ltr">
			<div class="loading">
				<span data-text="I">I</span>
				<span data-text="R">R</span>
				<span data-text="A">A</span>
				<span data-text="Q">Q</span>
				<!-- <span data-text="X">X</span> -->
			</div>
		</div>
		<!-- PreLoader End -->
		<section class="zirox-hero-section zirox-hero-section--home-2">
			<div class="container-fluid">
			<div class="home-2-hero-slider" dir="ltr" ref="slider">
				<!-- Slider Item -->
				<div class="zirox-hero__slider-item zirox-hero">
				<img
					src="@/assets/img/home-2/SN1.png"
					class="img-fluid"
					alt="Slide 1"
				/>
				</div>
				<!-- Slider Item End -->

				<!-- Slider Item -->
				<div class="zirox-hero__slider-item zirox-hero">
				<img
					src="@/assets/img/home-2/s-n-2.webp"
					class="img-fluid"
					alt="Slide 2"
				/>
				</div>
				<!-- Slider Item End -->
				<!-- Slider Item -->
				<div class="zirox-hero__slider-item zirox-hero">
				<img
					src="@/assets/img/home-2/33.webp"
					class="img-fluid"
					alt="Slide 2"
				/>
				</div>
				<!-- Slider Item End -->
			</div>
			</div>

			<!-- Time and Slider Controls -->
			<!-- <ul class="zirox-hero-section__time">
			<li>
				<i class="flaticon-sun"></i>
				<p>TODAY: 32 °C</p>
			</li>
			<li>
				<i class="flaticon-clock"></i>
				<p>TIME: 09:28 PM</p>
			</li>
			</ul> -->
			<div class="zirox-hero-section__slider-btn">
			<button class="zirox-hero-section__slider-btn__next">
				<i class="flaticon-right-arrow-2"></i>
			</button>
			<button class="zirox-hero-section__slider-btn__prev">
				<i class="flaticon-left-arrow-2"></i>
			</button>
			</div>

			<!-- Service Section -->
			<div class="zirox-hero-section__service" dir="rtl">
			<div class="container">
				<ul>
				<li><p>*</p><h3>خدمات</h3></li>
				<li><p>*</p><h3>تكنولوجيا</h3></li>
				<li><p>*</p><h3>صناعة</h3></li>
				<li><p>*</p><h3>زراعة</h3></li>
				<li><p>*</p><h3>تجارة</h3></li>
				<li><p>*</p><h3>لوجيستيك</h3></li>
				</ul>
			</div>
			</div>
		</section>
		<!-- Hero Section End -->


		<!-- Introduction Section -->
		<section class="zirox-about zirox-about--introduction zirox-section" id="section1" dir="rtl">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-12 col-lg-6">
						<div class="zirox-about__left wow fadeInRight" data-wow-duration="1s">
							<img src="@/assets/img/about/irq2f.png" alt="Image">
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="zirox-about__right wow fadeInLeft" data-wow-duration="1s">
							<h2 style="color:#6FBD44;">حول الشركة</h2>
							<h3>جودة...تميز...ريادة</h3>
							<p class="zirox-about__right-text">شركة العراق القابضة هي إحدى الشركات الرائدة في العراق التي تتمتع برؤية استراتيجية طموحة تهدف إلى تحقيق الريادة والنمو المستدام في مجموعة واسعة من القطاعات. تسعى الشركة إلى التوسع داخل العراق ومن ثم إلى أسواق الدول العربية والدولية، حيث تركز على تقديم الحلول المتقدمة والخدمات المبتكرة في مختلف المجالات. تتألف شركة العراق القابضة من أكثر من 12 مشروعًا متميزًا تنتمي إلى قطاعات الحلول التقنية، الخدمات، و التجارة
							</p>
							<ul>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>خدمات</p>
								</li>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>تكنولوجيا</p>
								</li>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>صناعة</p>
								</li>
							</ul>
							<ul>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>زراعة</p>
								</li>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>تجارة</p>
								</li>
								<li>
									<i class="flaticon-tick-inside-circle"></i>
									<p>لوجيستيك</p>
								</li>
							</ul>
							<a href="#" class="zirox-button">تواصل معنا</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Introduction Section End -->


		<!-- Info Section -->
		<section class="zirox-info" dir="rtl">
			<div class="container zirox-choose-us__experience zirox-choose-us__experience--home-2">
				<div class="row align-items-center">
					<div class="col-12 col-lg-6">
						<div class="zirox-choose-us__experience__left">
							<a class="zirox-choose-us__experience__left__img popup-youtube" href="https://www.youtube.com/watch?v=bYsgGkKksvs">
								<i class="flaticon-play-button-arrowhead"></i>
							</a>	
							<div class="zirox-choose-us__experience__left__text">
								<h2 class="text-white">أفضل الحلول والمشاريع</h2>
								<p>نوفر أفضل الحلول والمشاريع الاستثمارية، مستندين إلى الابتكار والجودة لتحقيق عوائد مستدامة ونمو مستمر في مختلف القطاعات.</p>
								<a href="#section3" class="zirox-button">تواصل معنا</a>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="zirox-choose-us__experience__right">
							<div class="row">
								<div class="col-12">
									<img src="@/assets/img/latest-project/MAP.webp" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Info Section End -->


		<!-- Services Section -->
		<section class="zirox-services zirox-services--home-2 zirox-section" id="section2" dir="rtl">
			<div class="container">
				<h2 style="color:#6FBD44;  margin-bottom: 34px;">نطاقات عملنا</h2>
				<h4 style="max-width: 600px;
				text-align: center;
				margin-inline: auto;
				margin-bottom: 100px;">نستثمر في العديد من القطاعات والمجالات مع إلتزامنا بأعلى معايير الجودة والتميّز، لتحقيق نجاح مستدام ونمو متواصل</h4>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4" style ="margin-bottom: 9%;">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
									<img src="@/assets/img/services/Services.png" alt="UX Strategy">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع الخدمات</h3>
									<p>يقوم على تطوير حلول مبتكرة مدعومة بالتكنولوجيا الحديثة والذكاء الصناعي، مما يسهم في رفع الكفاءة التشغيلية، تسريع الاستجابة، وتقديم تجربة سلسة ومتكاملة تلبي احتياجات العملاء بطرق ذكية ومتطور من خلال الاعتماد على التحليل الذكي للبيانات، الأتمتة، والخدمات الرقمية التفاعلية
									</p>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
									<img src="@/assets/img/services/commerce.png" alt="Engineering">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع التجارة</h3>
									<p>يسعى إلى تنمية وتوسيع نطاق التجارة المحلية والدولية من خلال دعم سلاسل التوريد، تطوير الأسواق، وتعزيز الابتكار في الخدمات التجارية.  تساهم الشركة في تحفيز النمو الاقتصادي، تحسين كفاءة العمليات التجارية، وتعزيز تنافسية السوق الوطني على المستوى الإقليمي والعالمي
									</p>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
									<img src="@/assets/img/services/Logistics.png" alt="Consultancy">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع اللوجستيك</h3>
									<p>يسعى إلى تطوير بنية تحتية متكاملة للنقل، وتعزيز كفاءة سلاسل التوريد و يمثل هذا القطاع دعامة أساسية لدعم التجارة والصناعة، من خلال تحقيق التكامل اللوجستي، تحسين انسيابية العمليات، وزيادة المرونة التشغيلية لتلبية متطلبات الأسواق المحلية والدولية بفعالية عالية
									</p>
								</div>
							</div>
						</a>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
									<img src="@/assets/img/services/techo.png" alt="Consultancy">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع التكنولوجيا </h3>
									<p>يقود التحول الرقمي من خلال تطوير الحلول الذكية، تعزيز البنية التحتية التكنولوجية، والابتكار في مجالات الاتصالات والبرمجيات. يهدف القطاع إلى تحسين الكفاءة التشغيلية، دعم الاستدامة الرقمية، وتمكين الاقتصاد من خلال تبني التقنيات الحديثة، مما يسهم في بناء مستقبل رقمي متطور في العراق</p>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
									<img src="@/assets/img/services/Industrialinvestment.png" alt="Consultancy">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع الصناعة</h3>
									<p>يسعى إلى تعزيز الصناعات الوطنية، زيادة الإنتاج المحلي، وتبني أحدث التقنيات الصناعية لضمان كفاءة أعلى واستدامة طويلة الأمد. من خلال مشاريع صناعية متقدمة وتطوير سلاسل التوريد، و تحفيز النمو الاقتصادي، خلق فرص العمل، وتعزيز القدرة التنافسية للصناعات العراقية على المستويين المحلي والدولي </p>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<a href="#">
							<div class="zirox-services-box zirox-services-box--home-2">
								<div class="zirox-services-box-img">
                                    <img src="@/assets/img/services/Agriculturalinvestment.png" alt="Consultancy">
								</div>
								<div class="zirox-services-box-text">
									<h3>قطاع الزراعة</h3>
									<p>يركز على تحقيق الاستدامة الزراعية وتنمية الثروة الحيوانية من خلال تبني التقنيات الحديثة، تحسين استغلال الأراضي، وزيادة الإنتاجية. يهدف إلى تعزيز الأمن الغذائي، دعم الاقتصاد الوطني، وتحقيق الاكتفاء الذاتي عبر مشاريع زراعية وحيوانية متطورة تسهم في تطوير القطاع الزراعي.</p>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</section>
		<!-- Services Section End -->


		<!-- Latest Projects -->
		<section class="zirox-latest-projects zirox-section" id="section4" dir="rtl">
			<div class="container position-relative z-1">
			<div class="zirox-latest-projects__header">
				<div class="zirox-latest-projects__header-left">
				<h2 class="text-center text-xl-start" style="color: #6FBD44; display: inline-flex;">مشاريعنا</h2>&nbsp;
				<h2 class="text-center text-white" style="display: inline-flex;">جودة ... تميز ...ريادة</h2>
				</div>
				<div class="zirox-latest-projects__header-right">
				<ul class="zirox-latest-projects__header-right__tab">
					<li><button class="zirox-latest-projects__header-right__tab-link filter active" data-filter="all">الكل</button></li>
					<li><button class="zirox-latest-projects__header-right__tab-link filter" data-filter=".service" data-rel="service">خدمات</button></li>
					<li><button class="zirox-latest-projects__header-right__tab-link filter" data-filter=".branding" data-rel="branding">تكنولوجيا</button></li>
					<li><button class="zirox-latest-projects__header-right__tab-link filter" data-filter=".photography" data-rel="photography">صناعة</button></li>
					<li><button class="zirox-latest-projects__header-right__tab-link filter" data-filter=".zera2a" data-rel="zera2a">زراعة</button></li>
					<li><button class="zirox-latest-projects__header-right__tab-link filter" data-filter=".trading" data-rel="trading">تجارة</button></li>
				</ul>
				</div>
			</div>
			</div>
			<div class="container-fluid mt-5">
				<div class="row g-4 position-relative z-1" id="zirox-filter">
					<div class="col-12 col-md-6 col-lg-3 filter-item service">
						<a href="https://rahacar.com/" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/Raha.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة راحة للمساعدة على الطريق</h3>
										<p style="color: white;">
											هي إحدى الشركات الرائدة والمتخصصة في توفير خدمات المساعدة على الطريق. تأسست الشركة بهدف تلبية احتياجات السوق المحلي  وكالات السيارات لتوفير تجربة متكاملة ومميزة لخدمات ما بعد البيع ،  وشركات التأمين والشركات المالية من خلال تقديم حلول مبتكرة وفعالة لزبائهم حيث توفر  للسائقين في حالات الطوارئ على الطرق. تسعى الشركة إلى حيث تقدم الدعم الفوري للمركبات في حالات الأعطال، الحوادث ، أو أي مواقف طارئة أخرى تحدث أثناء السفر
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>

					

					<div class="col-12 col-md-6 col-lg-3 filter-item branding">
						<a href="http://www.fusionvts.com" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/Fusion.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة فيوجن</h3>
										<p style="color: white;">
											هي شركة رائدة في مجال تتبع المركبات، حيث تقدم حلولًا متطورة لإدارة الأساطيل وفقًا لأحدث الأنظمة التكنولوجية. تركز الشركة على تقديم خدمات مبتكرة تتيح للشركات والمؤسسات مراقبة وإدارة مركباتها بشكل دقيق وفعّال، مما يساهم في تحسين الكفاءة التشغيلية وتقليل التكاليف.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="col-12 col-md-6 col-lg-3 filter-item branding">
						<a href="http://www.alinsehar.com" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/alınsehar.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة الانصهار للاتصالات والتقنيات الإلكترونية والمعلوماتية</h3>
										<p style="color: white;">
											هي شركة متخصصة تقدم حلولاً تقنية متكاملة تتمحور حول تصميم وتجهيز وتنصيب وصيانة وتشغيل البنى التحتية المتطورة. تساهم الشركة بشكل فعال في إنشاء وتشغيل مراكز البيانات، مراكز الاتصالات، بالإضافة إلى مراكز الأمن السيبراني  والمراقبة ، مما يضمن عمل هذه المنشآت بكفاءة وأمان عالٍ
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="col-12 col-md-6 col-lg-3 filter-item service">
						<a href="https://sebar.agency/" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/SEBAR.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>وكالة سيبار</h3>
										<p style="color: white;">
											هي وكالة رائدة تقدم حلولاً إبداعية ومبتكرة في مجالات التسويق والدعاية وإدارة منصات التواصل الاجتماعي. تهدف الوكالة إلى مساعدتك في تعزيز تواجدك الرقمي وبناء استراتيجيات تسويقية فعّالة تساهم في توسيع نطاق أعمالك وزيادة تأثيرك في السوق.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="col-12 col-md-6 col-lg-3 filter-item branding">
						<a href="http://www.tawasell.com" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/Tawasell.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة تواصل</h3>
										<p style="color: white;">
										شركة تواصل هي شركة رائدة في تقديم أنظمة الاتصالات السحابية وحلول إدارة المكالمات المتطورة، حيث توفر خدمات استقبال الاتصالات والمكالمات نيابة عن الشركات والمؤسسات المختلفة. تعتمد الشركة على أحدث التقنيات السحابية لضمان تقديم حلول مرنة وفعالة تلبي احتياجات العملاء في مختلف القطاعات
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item service">
						<a href="https://www.arabiaeae.com/" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/arabia.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة العربية للمصاعد</h3>
										<p style="color: white;">
											هي شركة رائدة ومتخصصة في تصميم وتصنيع وتركيب وصيانة المصاعد والسلالم المتحركة. تأسست الشركة لتلبية احتياجات السوق في تقديم حلول مبتكرة وفعّالة في مجال التنقل العمودي، حيث تسعى إلى توفير منتجات ذات جودة عالية تلبي أعلى معايير الأمان والكفاءة
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item trading">
						<a href="https://magicsupplier.net/" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/magicsupplier.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3> تطبيق ماجك سبلاير</h3>
										<p style="color: white;">  
										هو منصة مبتكرة للتجارة الإلكترونية المتخصصة في تقديم مستلزمات الفنادق، صالونات الحلاقة، والمطاعم ذات الاستخدام الواحد. يوفر التطبيق مجموعة واسعة من المنتجات عالية الجودة التي تلبي احتياجات هذه القطاعات المختلفة، بالإضافة إلى ميزة فريدة تتمثل في إمكانية الطباعة على المستلزمات وفقاً لمتطلبات الزبائن والعلامات التجارية.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item trading">
						<a href="http://www.my-car.app" target="_blank"> 
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/sayarate.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3> تطبيق سيارتي</h3>
										<p style="color: white;">
										تطبيق رائد في مجال التجارة الإلكترونية المتخصصة في قطاع السيارات، حيث يقدم منصة شاملة لبيع مختلف منتجات السيارات بأعلى جودة وأسعار تنافسية. يتيح التطبيق لمستخدميه الوصول بسهولة إلى مجموعة واسعة من المنتجات الضرورية لصيانة السيارات مثل الزيوت، البطاريات، قطع الغيار، والإكسسوارات، بالإضافة إلى العديد من المنتجات الأخرى التي تساهم في تحسين أداء السيارة وتلبية احتياجات مالكيها.
									</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item branding">
						<a href="http://www.radar-vts.com" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/radar.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة رادار للتتبع وإدارة الأساطيل</h3>
										<p style="color: white;">
										شركة مبتكرة ومتخصصة في توفير حلول متقدمة لتتبع المركبات وإدارة الأساطيل. تقدم الشركة منصة احترافية ذات تقنيات متطورة، تعتمد على الذكاء الصناعي لضمان أعلى مستوى من الدقة والكفاءة في مراقبة وتحليل حركة المركبات.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item zera2a">
						<a href="http://www.gardeniahoney.com">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/cardenishoney.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>مناحل غاردينيا</h3>
										<p style="color: white;">
                                            مشروع مبتكر ومتخصص في إنتاج العسل الطبيعي العضوي، حيث نعتمد على التنوع البيئي الغني في الجمهورية التركية. بتوافر مزيج من الزهور البرية والنباتات الطبيعية التي تزخر بها الأرض التركية، استثمرنا في هذه الموارد الفريدة لتقديم عسل طبيعي وصحي يمتاز بجودته العالية ونكهته المميزة.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
					<div class="col-12 col-md-6 col-lg-3 filter-item service">
						<a href="http://www.aliraq.tv" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/iraqArtisticproduction.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>شركة العراق للإنتاج الفني والدعاية والإعلان وتنظيم المعارض والمؤتمرات</h3>
										<p style="color: white;">
											هي إحدى الشركات الرائدة في مجال صناعة الإعلام والفعاليات في العراق. تأسست الشركة بهدف تقديم حلول إبداعية ومتكاملة لعملائها، عبر تقديم خدمات متميزة في مجالات الإنتاج الفني، الحملات الإعلانية، وتنظيم الفعاليات التجارية والثقافية.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="col-12 col-md-6 col-lg-3 filter-item service">
						<a href="http://www.rahaexpress.com" target="_blank">
							<div class="zirox-latest-projects-item flip-card">
								<div class="flip-card-inner">
									<div class="flip-card-front">
										<img src="@/assets/img/latest-project/rahaexpres.png" alt="">
									</div>
									<div class="flip-card-back">
										<h3>راحة للتوصيل السريع</h3>
										<p style="color: white;">
										هي شركة ناشئة مبتكرة في مجال خدمات التوصيل السريع، تهدف إلى تغيير طريقة نقل البضائع والطلبات عبر تقديم حلول لوجستية متطورة وسريعة. تعتمد الشركة بشكل رئيسي على تقنيات الذكاء الصناعي لإدارة أعمالها وتحسين كفاءة عمليات التوصيل، مما يضمن تقديم خدمة أسرع وأكثر دقة للعملاء.
										</p>
									</div>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</section>
		<!-- Latest Projects End -->
		<!-- Contact -->
		<!-- <section class="zirox-contact zirox-contact--single" id="section3" dir="rtl">
			<div class="container">
				<h2>تواصل معنا</h2>
				<div class="row">
					<div class="col-12 col-md-8 col-lg-4">
						<div class="zirox-contact__left">
							<div class="zirox-contact__left-box">
								<div class="zirox-contact__left-box-img">
									<i class="flaticon-place"></i>
								</div>
								<div class="zirox-contact__left-box-detail">
									<h3>العنوان</h3>
									<address>العراق - بغداد</address>
								</div>
							</div>
							<div class="zirox-contact__left-box">
								<div class="zirox-contact__left-box-img">
									<i class="flaticon-call"></i>
								</div>
								<div class="zirox-contact__left-box-detail">
									<h3>الهاتف</h3>
									<a href="tel:+9647809809809">9647809809809+</a>
								</div>
							</div>
							<div class="zirox-contact__left-box">
								<div class="zirox-contact__left-box-img">
									<i class="flaticon-open-mail-1"></i>
								</div>
								<div class="zirox-contact__left-box-detail">
									<h3>البريد الالكتروني </h3>
									<a href="mailto:info@ir2q.com">info@ir2q.com</a>
								</div>
							</div>
						</div>
					</div>
						<div class="col-12  col-lg-8">
							<div class="zirox-contact__right">
								<div class="zirox-contact__right-form">
									<form action="/" method="POST" id="contact-form">
										<div class="row">
											<div class="col-12 col-md-6">
												<input type="text" name="fullname" id="fullname" placeholder="الاسم الكامل">
											</div>
											<div class="col-12 col-md-6">
												<input type="email" name="email" id="email" placeholder="عنوان البريد الالكتروني">
											</div>
											<div class="col-12 col-md-6">
												<input type="text" name="phone" id="phone" placeholder="الهاتف">
											</div>
											<div class="col-12 col-md-6">
												<input type="text" name="Subject" id="Subject" placeholder="الموضوع">
											</div>
											<div class="col-12 py-4">
												<select name="company" id="company" class="col-12 ">
													<option value="" disabled selected>اختر الشركة</option>
													<option value="radar">رادار للتتبع وإدارة الأساطيل</option>
													<option value="raha-express">راحة للتوصيل السريع</option>
													<option value="tawasell">تواصل</option>
													<option value="magic-supplier">تطبيق ماجيك سبلاير </option>
													<option value="syarate">تطبيق سيارتي</option>
													<option value="sebar">وكالة سيبار </option>
													<option value="gardienia">مناخل غاردينيا</option>
													<option value="arabia">العربية للمصاعد</option>
													<option value="fusion">فيوجن</option>
													<option value="insehar">الانصهار</option>
													<option value="raha">راحة للمساعدة على الطريق</option>
												</select>
											</div>											
											<div class="col-12">
												<textarea name="message" id="message" cols="30" rows="10" placeholder="رسالتك"></textarea>
											</div>
										</div>
										<button class="zirox-button">ارسال الرسالة</button>
									</form>
								</div>
							</div>
						</div>
				</div>
			</div>
			<div class="zirox-contact__map">
				<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3334.1810847781976!2d44.430910999999995!3d33.31408100000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDE4JzUwLjciTiA0NMKwMjUnNTEuMyJF!5e0!3m2!1sar!2str!4v1741334644419!5m2!1sar!2str" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div>
		</section> -->
		
		<section class="zirox-contact zirox-contact--single" id="section3" dir="rtl">
			<div class="container">
			<h2>تواصل معنا</h2>
			<div class="row">
				<div class="col-12 col-md-8 col-lg-4">
				<div class="zirox-contact__left">
					<div class="zirox-contact__left-box">
					<div class="zirox-contact__left-box-img">
						<i class="flaticon-place"></i>
					</div>
					<div class="zirox-contact__left-box-detail">
						<h3>العنوان</h3>
						<p>العراق - بغداد</p>
					</div>
					</div>
					<div class="zirox-contact__left-box">
					<div class="zirox-contact__left-box-img">
						<i class="flaticon-call"></i>
					</div>
					<div class="zirox-contact__left-box-detail">
						<h3>الهاتف</h3>
						<a href="tel:009647809809809">009647809809809</a>
					</div>
					</div>
					<div class="zirox-contact__left-box">
					<div class="zirox-contact__left-box-img">
						<i class="flaticon-open-mail-1"></i>
					</div>
					<div class="zirox-contact__left-box-detail">
						<h3>البريد الالكتروني</h3>
						<a href="mailto:info@ir2q.com">info@ir2q.com</a>
					</div>
					</div>
				</div>
				</div>
				<div class="col-12 col-lg-8">
				<div class="zirox-contact__right">
					<div class="zirox-contact__right-form">
					<form @submit.prevent="sendEmail">
						<div class="row">
						<div class="col-12 col-md-6">
							<input v-model="form.fullname" type="text" placeholder="الاسم الكامل" required />
						</div>
						<div class="col-12 col-md-6">
							<input v-model="form.email" type="email" placeholder="عنوان البريد الالكتروني" required />
						</div>
						<div class="col-12 col-md-6">
							<input v-model="form.phone" type="text" placeholder="الهاتف" required />
						</div>
						<div class="col-12 col-md-6">
							<input v-model="form.subject" type="text" placeholder="الموضوع" required />
						</div>
						<div class="col-12 py-4">
							<select v-model="form.company" class="col-12" required>
							<option value="" disabled selected>اختر الشركة</option>
							<option v-for="(email, company) in companyEmails" :key="company" :value="company">
								{{ company }}
							</option>
							</select>
						</div>
						<div class="col-12">
							<textarea v-model="form.message" cols="30" rows="10" placeholder="رسالتك" required></textarea>
						</div>
						</div>
						<button class="zirox-button" type="submit">ارسال الرسالة</button>
					</form>
					<p v-if="successMessage" class="success-message">{{ successMessage }}</p>
					<p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
					</div>
				</div>
				</div>
			</div>
			</div>
		</section>
		
		<!-- Footer -->
		<footer class="zirox-footer zirox-section" dir="rtl">
			<div class="container">
				<div class="row">
					<div class="col-12 col-md-8 col-lg-3">
						<div class="zirox-footer__about">
							<img src="@/assets/img/Logo.png" alt="Logo">
							<p class="zirox-footer__about-text">شركة العراق القابضة هي إحدى الشركات الرائدة في العراق التي تتمتع برؤية استراتيجية طموحة تهدف إلى تحقيق الريادة والنمو المستدام في مجموعة واسعة من القطاعات.</p>
							<!-- <ul class="zirox-footer__about__socials">
								<li>
									<a href="#">
										<i class="flaticon-twitter"></i>
									</a>
								</li>
								<li>
									<a href="#">
										<i class="flaticon-facebook-logo-in-circular-shape"></i>
									</a>
								</li>
								<li>
									<a href="#">
										<i class="flaticon-pinterest"></i>
									</a>
								</li>
								<li>
									<a href="#">
										<i class="flaticon-instagram"></i>
									</a>
								</li>
							</ul> -->

						</div>	
					</div>
					<div class="col-12 col-md-4 col-lg-2">
						<div class="zirox-footer__explore">
							<h3>روابط سريعة</h3>
							<ul>
								<li><a href="#section1">حول الشركة</a></li>
								<li><a href="#section2">نطاقات عملنا</a></li>
								<li><a href="#section4">مشاريعنا</a></li>
								<li><a href="#section3">اتصل بنا</a></li>
							</ul>
						</div>	
					</div>
					<div class="col-12 col-md-5 col-lg-3">
						<div class="zirox-footer__gallery">
							<h3>معرض الصور</h3>
							<div class="row">
								<div class="col-4 mb-3">
									<img src="@/assets/img/footer/1.png" alt="Image 1" class="footer-gallery-item">
								</div>
								<div class="col-4 mb-3">
									<img src="@/assets/img/footer/2.png" alt="Image" class="footer-gallery-item">
								</div>
								<div class="col-4 mb-3">
									<img src="@/assets/img/footer/3.png" alt="Image 3" class="footer-gallery-item">
								</div>
								<!-- <div class="col-4 mb-3">
									<a href="@/assets/img/footer/footer-img-4.png" class="footer-gallery-item" title="Image 4">
										<img src="@/assets/img/footer/footer-img-4.png" alt="Image 4">
									</a>
								</div>
								<div class="col-4 mb-3">
									<a href="@/assets/img/footer/footer-img-5.png" class="footer-gallery-item" title="Image 5">
										<img src="@/assets/img/footer/footer-img-5.png" alt="Image 5">
									</a>
								</div>
								<div class="col-4 mb-3">
									<a href="@/assets/img/footer/footer-img-6.png" class="footer-gallery-item" title="Image 6">
										<img src="@/assets/img/footer/footer-img-6.png" alt="Image 6">
									</a>
								</div> -->
							</div>
						</div>	
					</div>
					<div class="col-12 col-md-7 col-lg-4">
						<div class="zirox-footer__news-letter">
							<h3>النشرة الاخبارية</h3>
							<form action="/" method="POST" id="news-letter-form">
								<input type="email" name="news-letter" id="news-letter" placeholder="عنوان البريد الالكتروني" required>
								<button type="submit" id="news-letter-submit">
									<i class="flaticon-send-1"></i>
								</button>
							</form>
							<ul>
								<li>
									<i class="flaticon-check-mark"></i>
									تحديثات اسبوعية
								</li>
							</ul>
						</div>	
					</div>
				</div>
			</div>
			<div class="zirox-footer__bar" >
				<div class="container">
					<div class="zirox-footer__bar-content">
						<a href="" class="zirox-footer__bar-content-scroll-top scrollUp">
							<i class="flaticon-up-arrow"></i>
						</a>
						<p dir="rtl">&copy;2025 تم تطويره من قبل<a href="https://alinsehartec.com/" target="_blank" style="color:white">Alinsehartec</a></p>
					</div>
				</div>
			</div>
		</footer>
		<!-- Footer End -->
</template>

<script>
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import "slick-carousel";
import mixitup from "mixitup";

export default {
  setup() {
    const slider = ref(null);
    const form = ref({
      fullname: "",
      email: "",
      phone: "",
      subject: "",
      company: "",
      message: "",
    });

    const companyEmails = {
      "العراق القابضة": "info@ir2q.com",
      "رادار للتتبع وإدارة الأساطيل": "info@radar-vts.com",
      "راحة للتوصيل السريع": "info@rahaexpress.com",
      "تواصل": "info@tawasell.com",
      "تطبيق ماجيك سبلاير": "info@magicsupplier.net",
      "تطبيق سيارتي": "info@my-car.app",
      "وكالة سيبار": "info@sebar.agency",
      "مناحل غاردينيا": "info@gardeniahoney.com",
      "العربية للمصاعد": "info@arabiaeae.com",
      "فيوجن": "info@fusionvts.com",
      "الانصهار": "info@alinsehar.com",
      "راحة للمساعدة على الطريق": "info@rahacar.com",
      "العراق للانتاج الفني":"info@aliraq.tv",
    };

    const selectedEmail = computed(() => {
		return form.value.company ? companyEmails[form.value.company] || "" : "";

    });

	
    const successMessage = ref("");
    const errorMessage = ref("");

	const sendEmail = async () => {
	if (!form.value.company) {
		errorMessage.value = "يرجى اختيار الشركة!";
		return;
	}
	const response = await fetch("/send-email.php", {
		method: "POST",
		headers: {
		"Content-Type": "application/json",
		},
		body: JSON.stringify({
		fullname: form.value.fullname,
		email: form.value.email,
		phone: form.value.phone,
		subject: form.value.subject,
		company: form.value.company,
		message: form.value.message,
		to: selectedEmail.value,
		}),
	});

	const result = await response.json();

	if (result.success) {
		successMessage.value = "تم إرسال رسالتك بنجاح!";
		errorMessage.value = "";
		form.value = {
		fullname: "",
		email: "",
		phone: "",
		subject: "",
		company: "",
		message: "",
		};
	} else {
		errorMessage.value = "حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقًا.";
		successMessage.value = "";
		console.error(result.message);
	}
	};

    onMounted(() => {
      $(slider.value).slick({
        autoplay: true,
        dots: false,
        arrows: true,
        prevArrow: ".zirox-hero-section__slider-btn__prev",
        nextArrow: ".zirox-hero-section__slider-btn__next",
      });

      mixitup("#zirox-filter", {
        selectors: {
          target: ".filter-item",
        },
        animation: {
          duration: 500,
        },
      });
    });

    onBeforeUnmount(() => {
      $(slider.value).slick("unslick");
    });

    return {
      slider,
      form,
      companyEmails,
      selectedEmail,
      successMessage,
      errorMessage,
      sendEmail,
    };
  },
};
</script>

<style scoped>
.success-message {
  color: green;
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>
